module.exports = __webpack_public_path__ + "static/img/partner-logo-15.39a2fa72.png";